export const HomePageContent = {
  titles: {
    mainTitle: "Przeglądy i inspekcje bezpieczeństwa budynku",
    subTitle1: "Wybierz rozwiązanie dopasowane do typu nieruchomości",
    subTitle2: "Usługi, które zamówisz przez platformę",
  },
  electrical: {
    title: "Przeglądy elektryczne, pomiary i bezpieczeństwo zasilania",
    paragraphs: [
      "Instalacja elektryczna rzadko ostrzega, zanim pojawi się realny problem. Luźne połączenia, przegrzewające się zabezpieczenia albo zużyta izolacja mogą przez długi czas pozostać niewidoczne, a skończyć się awarią, porażeniem lub - co najgorsze - pożarem.",
      "Dlatego przez platformę inspektomat.pl zamówisz nie tylko obowiązkowy przegląd instalacji elektrycznej i odgromowej, ale również pomiary elektryczne, kontrolę rozdzielni, przegląd instalacji fotowoltaicznej i magazynu energii. To rozwiązanie dla mieszkań, domów, wspólnot, lokali usługowych i budynków firmowych.",
      "Możesz szukać wykonawcy do samej kontroli okresowej, odbioru po zmianach w instalacji albo diagnostyki konkretnego problemu, gdy zabezpieczenia wyłączają się zbyt często, instalacja była rozbudowywana albo planujesz dalszą modernizację obiektu.",
    ],
    subTitle: "Usługi elektryczne dostępne na platformie:",
    bullets: [
      "Przegląd instalacji elektrycznej: oględziny, pomiary oraz protokół okresowy",
      "Pomiary elektryczne: pomiary ochronne, rezystancji izolacji, uziemienia i skuteczności zabezpieczeń",
      "Przegląd instalacji odgromowej: kontrola stanu zwodów, połączeń i uziemienia",
      "Rozdzielnia elektryczna: kontrola, modernizacja albo wymiana układu zabezpieczeń",
      "Przegląd instalacji fotowoltaicznej i magazynu energii: ocena pracy źródła, zabezpieczeń i współpracy z instalacją budynku",
    ],
    note: "W wielu budynkach kontrola instalacji elektrycznej i piorunochronnej jest wymagana co najmniej raz na 5 lat zgodnie z art. 62 ust. 1 pkt 2 Prawa budowlanego.",
    closing:
      "Znajdź wykonawcę do przeglądu, pomiarów albo modernizacji instalacji elektrycznej w swojej nieruchomości.",
  },
  gas: {
    title: "Przeglądy gazowe, próby szczelności i kotły gazowe",
    paragraphs: [
      "Nieszczelna instalacja, zużyte przewody spalinowe albo źle wyregulowany kocioł to nie tylko ryzyko awarii. To realne zagrożenie pożarem, wybuchem albo zatruciem tlenkiem węgla.",
      "Na platformie znajdziesz wykonawców do rocznych przeglądów instalacji gazowej, prób szczelności, serwisu kotłów gazowych oraz odbiorów nowych i modernizowanych instalacji. To usługi potrzebne zarówno przy bieżącej eksploatacji, jak i przed uruchomieniem instalacji po pracach montażowych.",
      "Dzięki temu w jednym miejscu porównasz oferty do domu, mieszkania, lokalu lub budynku firmowego i wybierzesz wykonawcę do kontroli obowiązkowej, diagnostyki nieszczelności albo uporządkowania dokumentacji przed odbiorem.",
    ],
    subTitle: "Usługi gazowe dostępne na platformie inspektomat.pl:",
    bullets: [
      "Przegląd instalacji gazowej: kontrola szczelności i stanu technicznego instalacji",
      "Próba szczelności gazu: badanie nowej, naprawianej albo ponownie uruchamianej instalacji",
      "Przegląd kotła gazowego: czyszczenie, regulacja i analiza spalin",
      "Odbiór instalacji gazowej: kontrola wykonania, dokumentów i gotowości do uruchomienia",
    ],
    closing:
      "Porównaj lokalne oferty i wybierz wykonawcę z odpowiednimi uprawnieniami do przeglądu gazowego lub serwisu kotła.",
  },
  smoke: {
    title: "Kominy, wentylacja i pozostałe przeglądy bezpieczeństwa",
    description: [
      "Bezpieczny budynek to nie tylko instalacja elektryczna i gazowa. Równie ważne są drożne przewody kominowe, sprawna wentylacja, regularny serwis klimatyzacji i pomp ciepła oraz kontrole systemów przeciwpożarowych i stanu technicznego obiektu.",
      "Dlatego na platformie znajdziesz zarówno wykonawców do przeglądu kominiarskiego, wentylacji mechanicznej, klimatyzacji i pomp ciepła, jak i firmy od systemów wykrywania pożaru, sprzętu przeciwpożarowego, zabezpieczeń ewakuacyjnych oraz przeglądów budowlanych.",
      "To odpowiednie rozwiązanie, gdy chcesz uporządkować kilka obowiązków w jednym momencie i znaleźć wykonawców do różnych przeglądów bez przeszukiwania osobno każdej branży.",
    ],
    subTitle: "Pozostałe usługi bezpieczeństwa budynku:",
    bullets: [
      "Przegląd kominiarski: kontrola przewodów spalinowych, dymowych i wentylacyjnych",
      "Przegląd wentylacji, klimatyzacji i pompy ciepła: serwis układów odpowiedzialnych za jakość powietrza i komfort pracy",
      "Przegląd systemów wykrywania pożaru: czujniki dymu, czujniki ciepła i systemy SSP/SAP",
      "Przegląd sprzętu przeciwpożarowego oraz zabezpieczeń ewakuacyjnych: gaśnice, hydranty, drzwi ppoż., oświetlenie ewakuacyjne i oddymianie",
      "Przegląd budowlany: roczna albo pięcioletnia kontrola stanu technicznego budynku",
    ],
    note: "Jeżeli odpowiadasz za budynek lub lokal, możesz przez platformę ułożyć przeglądy instalacyjne, kominowe, wentylacyjne i techniczne w jednym miejscu.",
  },
  materials: {
    electricalManual: "Instrukcja bezpieczeństwa elektrycznego",
    gasManual: "Instrukcja bezpieczeństwa gazowego",
    smokeManual: "Instrukcja bezpieczeństwa alarmów dymowych",
  },
  seo: {
    title: "Przeglądy instalacji elektrycznej, gazowej i kominowej",
    description:
      "Porównaj oferty firm od przeglądów elektrycznych, gazowych, kominowych, wentylacyjnych, przeciwpożarowych i budowlanych. Wybierz usługę i miasto, aby znaleźć wykonawcę bez obdzwaniania rynku.",
  },
};
